export const SPEAKER_RESOLVER_EVIDENCE_TOPIC = 'speaker-resolver-evidence.state'
export const SPEAKER_RESOLVER_EVIDENCE_UPDATE_EVENT = 'speaker-resolver-evidence:update'

export interface SpeakerEvidenceEntry {
  dgIndex: string
  resolvedName: string | null
  isElimination: boolean
  votes: Record<string, number>
  totalVotes: number
  isManualOverride: boolean
}

export interface SpeakerResolverEvidenceSnapshot {
  revision: number
  speakers: Array<SpeakerEvidenceEntry>
  participantCount: number
  eliminationActive: boolean
}

export const EMPTY_SPEAKER_RESOLVER_EVIDENCE_SNAPSHOT: SpeakerResolverEvidenceSnapshot = {
  revision: 0,
  speakers: [],
  participantCount: 0,
  eliminationActive: false,
}
